import { PropertiesPanelPropertyConfig } from '../../../../../widgets/propertiesPanel';
import { MaterialConfigHelpers } from 'src/components/pages/preview3D/editors/editMaterialsEditor/editMaterialsEditorConfig';
import { T } from 'src/shared/helpers';

// LE RIGHE CHE IL PANNELLO NON AVEVA. Il foglio di mappatura ne chiede alcune che oggi non
// esistono da nessuna parte: l'intensità della normal map e la forza dell'occlusione. Sono
// proprietà che Babylon ha già — nessuna logica nuova, nessun calcolo: si leggono e si scrivono,
// come tutte le altre.
//
// NON C'È «Emissive illumination». Il foglio la chiede con data-track `useEmissiveAsIllumination`,
// che è una proprietà dello **StandardMaterial**: su `PBRMaterial` non esiste, e l'emissivo lì si
// dosa con `emissiveIntensity`, che sta già in Light contribution. Una riga legata a un nome che
// il tipo non ha non è una riga in meno: è un campo che finge di scrivere.
//
// STANNO QUI E NON NEL FILE CONDIVISO perché sono del pannello nuovo: aggiungerle di là le
// farebbe comparire anche nel vecchio editor, che nessuno ha chiesto di cambiare. La tabella del
// layout le nomina per id insieme a tutte le altre, e da lì in poi sono righe come le altre.
export const buildPbrExtraProperties = (material: BABYLON.PBRMaterial, helpers: MaterialConfigHelpers): PropertiesPanelPropertyConfig[] => [
    {
        // Il livello sta sulla TEXTURE, non sul materiale: senza normal map non c'è niente da
        // dosare, e un cursore acceso su un valore che non arriva da nessuna parte promette un
        // effetto che non si vedrà.
        type: 'range',
        id: 'normal-level',
        label: T._('Intensity', 'Admin'),
        value: material.bumpTexture?.level ?? 1,
        min: 0,
        max: 2,
        step: 0.01,
        disabled: !material.bumpTexture,
        onChange: (newValue) => {
            if (!material.bumpTexture) return;
            material.bumpTexture.level = newValue;
            helpers.updateState(material);
        }
    },
    {
        type: 'range',
        id: 'ambient-strength',
        label: T._('Occlusion', 'Admin'),
        value: material.ambientTextureStrength ?? 1,
        min: 0,
        max: 1,
        step: 0.01,
        onChange: (newValue) => {
            material.ambientTextureStrength = newValue;
            helpers.updateState(material);
        }
    }
];
